/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit',
	'../../lib/@waca/dashboard-common/dist/utils/HtmlXSSUtils'
], function(
	React,
	PropTypes,
	UI_Toolkit,
	HtmlXSSUtils
) {
	const { Component } = React;
	const { Container, FlexLayout, FlexItem, VSpacer, SVGIcon } = UI_Toolkit;

	class WidgetsContentContainer extends Component {

		componentDidMount() {
			const { handlers  } = this.props;
			handlers.componentDidMountCallback(this.props.containerClass, this.props.itemClass);
		}

		componentWillUnmount () {
			const { handlers  } = this.props;
			handlers.componentWillUnmountCallback(this.props.containerClass, this.props.itemClass);
		}

		render () {
			const { containerClass, items } = this.props;
			const contentItems = [];
			items.forEach((item) => {
				const itemMarkup = this.renderWidgetItem(item);
				if (itemMarkup) {
					contentItems.push(itemMarkup);
				}
			});
			if (contentItems.length) {
				return (
					<Container className={containerClass}>
						<FlexLayout
							fullHeight
							direction="column"
							justifyContent='flex-start'
						>
							<FlexItem>
								<VSpacer size={2} />
							</FlexItem>
							<FlexItem>
								<FlexLayout
									fullHeight
									direction="row"
									wrap='wrap'
								>
									{contentItems}
								</FlexLayout>
							</FlexItem>
						</FlexLayout>
					</Container>
				);
			}
			return null;
		}

		renderWidgetItem (item) {
			const icon = this._getIconMarkup(item);
			if (icon) {
				return (
					<FlexItem
						role={'group'} className='prop-item'
						data-name={item.name}
					>
						<FlexLayout
							fullHeight
							direction="column"
							alignItems='center'
							tabIndex={0}
							className='prop-icon'
							role={'button'}
							title={item.label}
							aria-label={item.label}
						>
							{icon}
						</FlexLayout>
					</FlexItem>
				);
			} else {
				return null;
			}
		}

		_getIconMarkup(item) {
			if (item.icon) {
				return this._renderIcon(item.icon);
			}
			if (item.svg) {
				return this._renderSvg(item.svg);
			}
			if (item.image) {
				return this._renderImage(item.image);
			}
			return null;
		}

		_renderIcon(iconId) {
			return (
				<FlexItem>
					<SVGIcon
						iconId={iconId}
						className='svgIcon'>
					</SVGIcon>
				</FlexItem>
			);
		}

		_renderSvg(svg) {
			return (
				<FlexItem>
					<div dangerouslySetInnerHTML={{ __html: HtmlXSSUtils.sanitizeHtml(svg) }} />
				</FlexItem>
			);
		}

		_renderImage(image) {
			const { imageLink, altText } = image;
			return (
				<FlexItem>
					<img src={imageLink} alt={altText}/>
				</FlexItem>
			);
		}
	}

	WidgetsContentContainer.propTypes = {
		items: PropTypes.array.isRequired,
		containerClass: PropTypes.string.isRequired,
		itemClass: PropTypes.string.isRequired,
		handlers: PropTypes.shape({
			componentDidMountCallback: PropTypes.func.isRequired,
			componentWillUnmountCallback: PropTypes.func.isRequired
		}).isRequired
	};

	return WidgetsContentContainer;
});
